var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard container"},[(_vm.client)?_c('FileManager',{attrs:{"client":_vm.client,"folder":_vm.folder,"file":_vm.file}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }